import React, { FunctionComponent, ReactNode, useContext } from 'react';
import { BikeRelay40YearsContext } from './context/bike-relay-40-years-context';
import { utilNumberFormat } from '../../../utils';

const BikeRelay40YearsInfo: FunctionComponent = () => {
  const { currentRelayPoint, totalDistance, traveledDistance, currentDate } =
    useContext(BikeRelay40YearsContext);

  const getCurrentRelayPointKilometers = currentRelayPoint?.reduce(
    (sum, point) => sum + (point.kilometers || 0),
    0
  );

  return (
    <>
      <div className={`md:flex justify-between`}>
        <InfoBox tailWindClasses={`w-full md:w-2/3`}>
          <div className={`flex`}>
            <h3 className={`mr-4 text-white`}>
              Huidige etappe: {currentDate}, {getCurrentRelayPointKilometers} km
            </h3>
          </div>
          <div>
            {currentRelayPoint?.map(
              (point, index) =>
                point?.kilometers > 0 && (
                  <p key={index}>
                    {point?.vanVestiging} naar {point?.naarVestiging}
                  </p>
                )
            )}
          </div>
        </InfoBox>

        <InfoBox tailWindClasses={`md:ml-4 w-full md:w-1/3`}>
          <InfoBoxItem>Afstand gefietst: {utilNumberFormat(traveledDistance)} km</InfoBoxItem>
          <InfoBoxItem>
            Nog te fietsen: {utilNumberFormat(totalDistance - traveledDistance)} km
          </InfoBoxItem>
        </InfoBox>
      </div>
    </>
  );
};

interface InfoBoxProps {
  children?: ReactNode;
  tailWindClasses?: string;
}

const InfoBox = ({ children, tailWindClasses }: InfoBoxProps) => {
  return (
    <div className={`p-4 rounded-lg !text-white bg-blue-500 mb-4 ${tailWindClasses}`}>
      {children}
    </div>
  );
};

const InfoBoxItem = ({ children }: InfoBoxProps) => {
  return <h3 className={`text-white`}>{children}</h3>;
};

export default BikeRelay40YearsInfo;
